export const splitDimensions = (dimensions) => {

  if (!dimensions) return {};

  let arraySplitX = dimensions.split('x');
  let arraySplitComma = arraySplitX[2].split(",");
  const dimensionsArray = {
    depth: arraySplitComma[0].trim(), // Largo
    width: arraySplitX[1].trim(),  // Ancho
    height: arraySplitX[0].trim(), // Alto
    weight: arraySplitComma[1].trim() // Peso
  };

  return dimensionsArray;

}


export const validateDimensions = ({
  width,
  height,
  depth,
  weight
}) => {

  const limits = {
    height: 500, // altura
    width: 500,  // ancho
    depth: 500,  // profundidad
    weight: 500000 // peso en gramos
  };

  const errores = [];

  for (const [key, limit] of Object.entries(limits)) {
    if (Number(eval(key)) > limit) {
      errores.push(`'${traducirClave(key)}' excede el límite de ${limit}.`);
    }
  }

  if (errores.length > 0) {
    throw new Error(`Revisar dimensiones:\n${errores.join('\n')}`);
  }
};

const traducirClave = (key) => {
  const traducciones = {
    height: "Alto",
    width: "Ancho",
    depth: "Largo",
    weight: "Peso"
  };
  return traducciones[key] || key;
};
